import { mapGetters } from "vuex";
import EventBus from "@/event-bus";

export default {
  data() {
    return {
      installments: [2, 3],
      fullInstallments: [1, 2, 3],
      indexSelect: 1,
      displayDividedPriceInfos: false,
      totalPrice: 0,
      dividedPrice: 0,
    };
  },

  computed: {
    ...mapGetters({ 
      isPac: "isPac",
      totalPriceProps: "getCurrentCartTotal",
    }),
  },

  mounted() {
    localStorage.getItem("devider") && !this.isPac
      ? (this.indexSelect = parseInt(localStorage.getItem("devider")))
      : 1;
      
      this.updatePriceByInstallments();
      this.handleDividedPriceInfos();
      
  },

  methods: {
    updateInstallments(e) {
      const id = parseInt(e.target.id);
      try {
        localStorage.setItem("devider", id);
      } catch (error) {
        console.error(error);
      }
      this.indexSelect = id;
      this.updatePriceByInstallments();
      this.handleDividedPriceInfos();
      EventBus.$emit("update-installments");
    },

    handleDividedPriceInfos() {
      if(this.indexSelect > 1) {
        this.displayDividedPriceInfos = true;
      } else {
        this.displayDividedPriceInfos = false;
      }
    },

    updatePriceByInstallments() {
      try {
        let devider = localStorage.getItem("devider");
        
        if (devider && devider != 0 && devider != "NaN") {
          this.totalPrice = this.totalPriceProps 
          this.dividedPrice = this.totalPriceProps / devider;
        } else {
          this.dividedPrice = this.totalPriceProps;
        }
      } catch (error) {
        
      }
    },
  },
};
